import { EventTypes, Locations, track } from '@mc/track-event'

export const trackEmailRecipeClick = (href, linkCopy, textTag) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: Locations.EMAIL_RECIPE_CARD,
    href,
    linkCopy,
    textTag: textTag || 'button',
  })
}

export const trackIngredientClick = (recipe, parent = document) => {
  const recipeContainers = parent.getElementById(recipe.id)
  const recipeSteps = Array.from(
    recipeContainers.getElementsByClassName('mc-input-checkbox'),
  )

  if (recipeSteps.length > 0) {
    recipeSteps.forEach((step) => {
      const label = step.getElementsByTagName('label')[0]
      const labelText = label.innerText.trim()
      const input = step.getElementsByTagName('input')[0]

      step.onclick = (event) => {
        event.stopPropagation()
        event.preventDefault()
        step.classList.toggle('mc-input-checkbox--checked')
        const checkboxAriaCheckedStatus = input.getAttribute('aria-checked')
        input.setAttribute(
          'aria-checked',
          checkboxAriaCheckedStatus === 'true' ? 'false' : 'true',
        )
        track(EventTypes.ARTICLE_PAGE_RECIPE_CLICK, {
          label: labelText,
          title: recipe.title,
          category: 'Articles',
        })
      }
    })
  }
}
